import BelovedApp from './Beloved';

function App() {
  return <BelovedApp />;
}

export default App;
